import { createSlice } from "@reduxjs/toolkit";
import switchUserRole from "@custom/rtk-apis/user/switchRole";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const switchRoleSlice = createSlice({
  name: "switchRoleSlice",
  initialState,
  reducers: {
    closeUserListModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(switchUserRole.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(switchUserRole.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(switchUserRole.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default switchRoleSlice.reducer;
export const { closeUserListModal } = switchRoleSlice.actions;
